import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/shared/atoms/Logo';
import { DesktopNav } from './DesktopNav';
import { MobileNav } from './MobileNav';
import { CartIcon } from './CartIcon';
import { CurrencySelector } from '@/components/shared/molecules/CurrencySelector';
import { Button } from '@/components/ui/button';
import { LoginModal } from '@/components/auth/LoginModal';
import { LogIn, LogOut, User as UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useAuthStore } from '@/store/authStore';
import { getCurrentUser, logout } from '@/services/erpnextAuth';

export const Header = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);
  const clearUser = useAuthStore((state) => state.clearUser);

  // Check auth status on mount
  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    };
    checkAuth();
  }, [setUser]);

  const handleLogout = async () => {
    await logout();
    clearUser();
  };

  return (
    <>
      <motion.header
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80"
      >
        <div className="container mx-auto px-4 md:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* Left side - Mobile menu + Logo */}
            <div className="flex items-center gap-4">
              <MobileNav />
              <Logo />
            </div>

            {/* Center - Desktop navigation */}
            <DesktopNav />

            {/* Right side - Auth + Currency selector + Cart */}
            <div className="flex items-center gap-2 md:gap-4">
              {user ? (
                <>
                  <Link to="/account" className="hidden md:flex items-center gap-2 text-sm hover:text-brand-primary transition-colors">
                    <UserIcon className="w-4 h-4" />
                    <span className="text-gray-700">{user.full_name}</span>
                  </Link>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={handleLogout}
                    className="text-gray-700"
                  >
                    <LogOut className="w-4 h-4 md:mr-2" />
                    <span className="hidden md:inline">Logout</span>
                  </Button>
                </>
              ) : (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setShowLoginModal(true)}
                  className="text-gray-700"
                >
                  <LogIn className="w-4 h-4 md:mr-2" />
                  <span className="hidden md:inline">Login</span>
                </Button>
              )}
              <CurrencySelector />
              <CartIcon />
            </div>
          </div>
        </div>
      </motion.header>

      <LoginModal open={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </>
  );
};
